import _ from 'lodash'
import { connect } from 'react-redux'

const withSupplierSharedLink = Comp => connect(
  state => ({ sharedLink: _.get(state, 'supplier.sharedLink') })
)(Comp)

export default withSupplierSharedLink
